import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent, SearchComponent, WmsDialogBodyComponent, WmsDialogFooterComponent, WmsDialogHeaderComponent } from '@wms/components';
import { omit, pull } from 'lodash-es';
import { AppLocaleManagerService } from '@wms/i18n';
import { getClonedObject } from '@wm/core';
import { FilterPipe } from '@wm/components-base';

@Component({
  selector: 'wms-add-locale-dialog',
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    SearchComponent,
    FilterPipe
  ],
  templateUrl: './add-locale-dialog.component.html',
  styleUrls: ['./add-locale-dialog.component.less']
})
export class AddLocaleDialogComponent extends BaseComponent implements OnInit {

  @Output() onModalClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAddLocaleSave: EventEmitter<any> = new EventEmitter<any>();
  localeCodesMap: any = {};
  projectDefaultLanguage: string;
  supportedLocale: any = [];
  filteredLocaleCodesMap: any = {};
  languageSearchKey: string = '';
  private deleteLocaleList: any = [];

  constructor(private appLocaleService: AppLocaleManagerService) {
    super();
  }

  ngOnInit(): void {
    import('src/assets/resources/files/localeCodesMap').then(response => {
      this.localeCodesMap = response.localeCodesMap;
      this.updateFilteredLocaleCodesMap();
    });
    this.supportedLocale = getClonedObject(this.appLocaleService.supportedLocale);
    this.projectDefaultLanguage = this.projectService.getDetails().properties.defaultLanguage;
  }

  searchLanguage($event: any){
    this.languageSearchKey = $event.searchKey;
  }

  saveLocale() {
    this.onAddLocaleSave.emit(this.supportedLocale);
    this.closeModal();
  }

  deleteLocale(localeKey: any) {
    this.deleteLocaleList.push(localeKey);
    pull(this.supportedLocale, localeKey);
    this.updateFilteredLocaleCodesMap();
  }

  addLocale(localeid: any) {
    pull(this.deleteLocaleList, localeid);
    this.supportedLocale.push(localeid);
    this.updateFilteredLocaleCodesMap();
  }

  // updates the filteredLocaleCodesMap
  updateFilteredLocaleCodesMap() {
    this.filteredLocaleCodesMap = omit(this.localeCodesMap, this.supportedLocale);
  }

  closeModal() {
    this.onModalClose.emit();
  }
}
